import React from 'react';

import { ReactComponent as ArrowIcon } from 'images/simple-arrow-right-rounded-icon.svg';

import styles from './AccelerateYourGoalsSection.module.scss';

interface TrajectoryComparisonProps {
  currentValue: string;
  planneryValue: string;
}

const TrajectoryComparison: React.FC<TrajectoryComparisonProps> = ({ currentValue, planneryValue }) => (
  <div className={styles.comparison}>
    <div className={styles.comparisonColumn}>
      <p className={styles.comparisonTitle}>
        Current
        <br />
        Trajectory
      </p>
      <p className={styles.comparisonValue}>{currentValue}</p>
    </div>
    <ArrowIcon className={styles.comparisonArrow} />
    <div className={styles.comparisonColumn}>
      <p className={styles.comparisonTitle}>
        Trajectory with
        <br />
        Plannery
      </p>
      <p className={styles.comparisonValue}>{planneryValue}</p>
    </div>
  </div>
);

export default TrajectoryComparison;
